// extracted by mini-css-extract-plugin
module.exports = {"content":"PartnersDeals_content__x1KyX","planContent":"PartnersDeals_planContent__YpGQ6","image":"PartnersDeals_image__YFbrI"};